import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class ViewApplicationDetailsItamsConstants {
    // Labels
    static STEP_TITLE = "Details";
    static DETAILS_FORM_GROUP_NAME = "detailsForm";
    static DESCRIPTION_LABEL = "Description";
    static APPLICATION_TYPE_LABEL = "Application type";
    static TRADING_GOODS_LABEL = "Trading goods";
    static TRADING_GOODS_DESCRIPTION_LABEL = "Trading goods description";
    static PREVIOUS_APPLICATION_REFERENCE_NUMBER_LABEL = "Previous application reference number";
    // Controls
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "type";
    static TRADING_GOODS_CONTROL_NAME = "tradingGoods";
    static TRADING_GOODS_DESCRIPTION_FORM_CONTROL_NAME = "tradingGoodsDescription";
    static PREVIOUS_APPLICATION_REFERENCE_NUMBER_CONTROL_NAME = "previousReferenceNumber";
    static REFERENCE_NUMBER_CONTROL_NAME = "referenceNumber";
    // LookupNames
    static APPLICATION_TYPE_LOOKUP_NAME = "ApplicationType";
    static TRADING_GOODS_LOOKUP_NAME = "TradingGoods";
    // Validation messages
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, applicationType: {
            required: `Application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, tradingGoods: {
            required: `Trading goods ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, tradingGoodsDescription: {
            required: `Trading goods description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
